document.addEventListener("DOMContentLoaded", () => {
  let swat;
  let wishlistId;

  function initializeSaveForLater(swatInstance) {
    swat = swatInstance;
    // Get the first available wishlist
    swat.fetchLists({
      callbackFn: (lists) => {
        if (lists && lists.length > 0) {
          wishlistId = lists[0].lid;
          console.log("Using wishlist ID:", wishlistId);
          setupCartWishlistButtons();
        } else {
          console.error("No wishlists available");
        }
      },
      errorFn: (error) => {
        console.error("Error fetching wishlists:", error);
      },
    });
  }

  // Success callback.
  let onSuccess = function (data) {
    if (data) {
      removeItemFromCart(data);
    }
  };

  // Error Callback.
  let onError = function (error) {
    console.log("There was an Error, while Adding product to Wishlist", error);
  };

  function setupCartWishlistButtons() {
    const buttons = document.querySelectorAll(".swym-add-to-wishlist-button");

    if (!buttons) {
      console.error("No buttons found");
      return;
    }

    buttons.forEach((button) => {
      if (!button) {
        console.error("Button not found");
        return;
      }
      button.addEventListener("click", (e) => addCartItemToWishlist(e));
    });
  }

  const removeItemFromCart = async (data) => {
    const { empi } = data;
    const button = document.querySelector(
      `.swym-add-to-wishlist-button[data-product-id='${empi}']`
    );
    const lineIndex = button.dataset.lineIndex;
    const removeUrl = `/cart/change?line=${lineIndex}&quantity=0`;
    window.location.href = removeUrl;
  };

  const addCartItemToWishlist = (e) => {
    e.preventDefault();
    const { productUrl, productId, variantId } = e.currentTarget.dataset;

    if (!productUrl || !productId || !variantId || !wishlistId) {
      console.error("Missing required data for adding product to wishlist");
      return;
    }

    e.currentTarget.textContent = "Moving to wishlist...";

    const product = {
      du: productUrl,
      empi: productId,
      epi: variantId,
    };

    // Use the regular addToList method instead of SaveForLater
    swat.addToList(wishlistId, product, onSuccess, onError);
  };

  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  if (window.SwymCallbacks) {
    window.SwymCallbacks.push(initializeSaveForLater);
  }
});
